<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Locations' : 'Deleted Locations'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  @click="showCreateDialog = true"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.distributor_id"
                    :items="distributors"
                    item-text="display_name"
                    item-value="id"
                    label="Select Distributor"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account-tie"
                    clearable
                    :no-data-text="
                      distributors.length === 0
                        ? 'No distributors available'
                        : 'Loading distributors...'
                    "
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.country_id"
                    :items="countries"
                    item-text="description"
                    item-value="id"
                    label="Country"
                    @input="onCountryChange"
                    prepend-inner-icon="mdi-earth"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.state_id"
                    :items="states"
                    item-text="description"
                    item-value="id"
                    label="State"
                    @input="onStateChange"
                    prepend-inner-icon="mdi-map-marker-radius"
                    clearable
                    :disabled="!filter.country_id"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.city_id"
                    :items="cities"
                    item-text="description"
                    item-value="id"
                    label="City"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-city"
                    clearable
                    :disabled="!filter.state_id"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <!-- <v-card-title v-if="locations.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title> -->
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Country</th>
                      <th class="text-left">State</th>
                      <th class="text-left">City</th>
                      <th class="text-left">Address</th>
                      <th class="text-left">Distributor</th>
                      <th class="text-left">Created By</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="locations.length != 0">
                    <tr
                      v-for="(location, i) in locations"
                      :key="`location${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="location.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Location is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="location.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Location is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          location.country ? location.country.description : ""
                        }}
                      </td>
                      <td>
                        {{ location.state ? location.state.description : "" }}
                      </td>
                      <td>
                        {{ location.city ? location.city.description : "" }}
                      </td>
                      <td>{{ location.address || "" }}</td>
                      <td>
                        {{
                          location.distributor
                            ? location.distributor.first_name +
                              " " +
                              (location.distributor.last_name || "")
                            : "N/A"
                        }}
                      </td>
                      <td>
                        {{
                          location.created_by
                            ? location.created_by.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{ location.created_at | niceDate }}
                      </td>

                      <td class="text-right">
                        <template v-if="location.is_deleted != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(location)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this location</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openEditDialog(location)"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this location</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(location.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this location</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                v-model="page"
                :length="paginationLength"
                @input="getData"
              >
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_location" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Location deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_location = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_location" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Location restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_location = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete Location"
      message="This action cannot be undone."
      icon="mdi-delete"
      color="error"
      :loading="delete_user"
      @confirm="Delete_this(pendingDeleteId)"
    >
      <template v-slot:details>
        <v-alert v-if="pendingDeleteLocation" outlined color="error" class="mt-3 mb-0" dense>
          <div class="d-flex align-center">
            <v-avatar color="error" size="36" class="mr-3">
              <v-icon color="white" size="18">mdi-map-marker</v-icon>
            </v-avatar>
            <div>
              <div class="font-weight-bold">
                {{ pendingDeleteLocation.address || "No address" }}
              </div>
              <div class="text-caption grey--text text--darken-1">
                {{ [pendingDeleteLocation.city, pendingDeleteLocation.state, pendingDeleteLocation.country].filter(x => x).map(x => x.description).join(", ") || "No city/state/country" }}
              </div>
            </div>
          </div>
        </v-alert>
      </template>
    </ConfirmationDialog>

    <!-- Add Location -->
    <AppDialog
      :show.sync="showCreateDialog"
      max-width="900"
      persistent
      icon="mdi-map-marker"
      title="Add Location"
      subtitle="Add a country/state/city location record"
    >
      <LocationCreatePage
        v-if="showCreateDialog"
        embedded
        @created="onLocationCreated"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Edit Location -->
    <AppDialog
      :show.sync="showEditDialog"
      max-width="900"
      persistent
      icon="mdi-map-marker"
      title="Edit Location"
      subtitle="Update this location's details"
    >
      <LocationEditPage
        v-if="showEditDialog"
        embedded
        :location-id="editingId"
        @saved="onLocationUpdated"
        @close="showEditDialog = false"
      />
    </AppDialog>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import AppDialog from "@/components/AppDialog.vue";
import LocationCreatePage from "./create.vue";
import LocationEditPage from "./id.vue";
export default {
  components: { ConfirmationDialog, AppDialog, LocationCreatePage, LocationEditPage },
  data() {
    return {
      locations: [],
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      deleteDialog: false,
      pendingDeleteId: null,
      pendingDeleteLocation: null,
      delete_user: false,
      filter: {
        search_keyword: "",
        is_active: "",
        distributor_id: null,
        country_id: null,
        state_id: null,
        city_id: null,
      },
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      deletedOptions: [
        { text: "Show Active", value: false },
        { text: "Show Deleted", value: true },
      ],
      distributors: [],
      countries: [],
      states: [],
      cities: [],
      isLoading: false,
      isExcelloading: false,
      is_deleted_location: false,
      is_restored_location: false,
      page: 1,
      paginationLength: 0,
    };
  },
  created() {
    this.getData();
    this.fetchCountries();
    this.fetchDistributors();
  },
  watch: {
    "$route.query.deleted": {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active =
        this.filter.is_active !== null ? this.filter.is_active : "";
      this.filter.distributor_id = this.filter.distributor_id || "";
      this.filter.country_id = this.filter.country_id || "";
      this.filter.state_id = this.filter.state_id || "";
      this.filter.city_id = this.filter.city_id || "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&is_active=" +
        this.filter.is_active +
        "&distributor_id=" +
        this.filter.distributor_id +
        "&country_id=" +
        this.filter.country_id +
        "&state_id=" +
        this.filter.state_id +
        "&city_id=" +
        this.filter.city_id;

      await axios
        .get(`locations?${query}`)
        .then((response) => {
          this.locations = response.data.data;
          this.paginationLength = Math.ceil(
            response.data.count / this.rowsPerPage
          );
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async fetchCountries() {
      try {
        const response = await axios.get("/location-countries");
        this.countries = response.data.data || [];
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    },
    async onCountryChange() {
      this.filter.state_id = null;
      this.filter.city_id = null;
      this.states = [];
      this.cities = [];

      if (this.filter.country_id) {
        try {
          const response = await axios.get("/location-states", {
            params: { country_id: this.filter.country_id },
          });
          this.states = response.data.data || [];
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      }
      this.page = 1;
      this.getData();
    },
    async onStateChange() {
      this.filter.city_id = null;
      this.cities = [];

      if (this.filter.state_id) {
        try {
          const response = await axios.get("/location-cities", {
            params: { state_id: this.filter.state_id },
          });
          this.cities = response.data.data || [];
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      }
      this.page = 1;
      this.getData();
    },
    async fetchDistributors() {
      try {
        const response = await axios.get("/users");
        this.distributors = (response.data.data || [])
          .filter((user) => {
            return (
              user.position &&
              user.position.name &&
              user.position.name === "DISTRIBUTOR/DEALER"
            );
          })
          .map((user) => ({
            ...user,
            display_name: `${user.first_name} ${user.last_name || ""} (${
              user.phone
            })`,
          }));
      } catch (error) {
        console.error("Error fetching distributors:", error);
      }
    },
    async Delete_this(id) {
      this.delete_user = true;
      await axios
        .post(`/locations/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_location = true;
          this.deleteDialog = false;
          this.pendingDeleteLocation = null;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        })
        .finally(() => {
          this.delete_user = false;
        });
    },
    askDelete(location) {
      this.pendingDeleteId = location.id;
      this.pendingDeleteLocation = location;
      this.deleteDialog = true;
    },
    onLocationCreated() {
      this.showCreateDialog = false;
      this.page = 1;
      this.getData();
    },
    openEditDialog(location) {
      this.editingId = this.encryptIt(location.id);
      this.showEditDialog = true;
    },
    onLocationUpdated() {
      this.showEditDialog = false;
      this.getData();
    },
    async Restore_this(id) {
      await axios
        .post(`/locations/restore/${id}`)
        .then(() => {
          this.is_restored_location = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
